import Vue from 'vue';
import { apolloClient } from '@/plugins/vue-apollo';
import { fetchSearchReportQuery, fetchCategories, fetchBuyers, fetchReportData, fetchProcessTypes, loadProcessTypes } from '@/store/graphql/queries/report';

export default {
  namespaced: true,
  state: {
    supplier_match: [],
    supplier_match_count: 0,
    categoriesSearchedInfo: [],
    buyersSearchedInfo: [],
    processTypeSearchedInfo: [],
    report_chart: [],
  },
  actions: {
    async fetchMatch({ commit }, filter) {
      try {
        const requestQuery = {
          fetchPolicy: 'network-only',
          query: fetchSearchReportQuery,
          variables: {
            from: filter.from,
            to: filter.to,
            limit: filter.limit,
            offset: filter.offset,
            buyer_id: filter.buyer_id,
            classcode: filter.classcode,
            search: filter.search,
            process_type: filter.process_type,
          },
        };

        if (!filter.buyer_id) {
          requestQuery.variables.buyer_id = '';
        }
        if (!filter.classcode) {
          requestQuery.variables.classcode = '';
        }
        if (!filter.search) {
          requestQuery.variables.search = '';
        }
        if (!filter.process_type) {
          requestQuery.variables.process_type = '';
        }
        const result = await apolloClient.query(requestQuery);
        if (result && result.data) {
          commit('SET_SUPPLIERMATCH', result.data.search_report);
          commit('SET_SUPPLIERMATCH_COUNT', result.data.search_report_aggregate.aggregate.count);
        }
      } catch (err) {
        window.console.error(err);
      }
    },
    async searchCategory({ commit }, filter) {
      try {
        const requestQuery = {
          fetchPolicy: 'network-only',
          query: fetchCategories,
          variables: {
            from: filter.from,
            to: filter.to,
            search: `${filter.search}%`,
          },
        };
        // validaciones de algun tipo
        const result = await apolloClient.query(requestQuery);
        if (result && result.data) {
          commit('SET_PROVIDERCATEGORIES', result.data.report_match);
        }
      } catch (err) {
        window.console.error(err);
      }
    },
    async searchBuyer({ commit }, filter) {
      try {
        const requestQuery = {
          fetchPolicy: 'network-only',
          query: fetchBuyers,
          variables: {
            from: filter.from,
            to: filter.to,
            search: `%${filter.search}%`,
          },
        };
        // validaciones de algun tipo
        const result = await apolloClient.query(requestQuery);
        if (result && result.data) {
          commit('SET_PROVIDERBUYERS', result.data.report_match);
        }
      } catch (err) {
        window.console.error(err);
      }
    },
    async searchProcessType({ commit }, filter) {
      try {
        const requestQuery = {
          fetchPolicy: 'network-only',
          query: fetchProcessTypes,
          variables: {
            from: filter.from,
            to: filter.to,
            search: `%${filter.search}%`,
          },
        };
        // validaciones de algun tipo
        const result = await apolloClient.query(requestQuery);
        if (result && result.data) {
          commit('SET_PROVIDERPROCESSTYPE', result.data.report_match);
        }
      } catch (err) {
        window.console.error(err);
      }
    },
    async loadProcessType({ commit }) {
      try {
        const requestQuery = {
          fetchPolicy: 'network-only',
          query: loadProcessTypes,
        };
        // validaciones de algun tipo
        const result = await apolloClient.query(requestQuery);
        if (result && result.data) {
          const nullIndex = result.data.report_match.findIndex(reportMatch => reportMatch.process_type === null);
          if (nullIndex === -1) return;
          result.data.report_match[nullIndex].process_type = 'Otros';
          commit('SET_PROVIDERPROCESSTYPE', result.data.report_match);
        }
      } catch (err) {
        window.console.error(err);
      }
    },
    async generateChartReport({ commit }, filter) {
      try {
        const requestQuery = {
          fetchPolicy: 'network-only',
          query: fetchReportData,
          variables: {
            from: filter.from,
            to: filter.to,
            buyer_id: filter.buyer_id,
            classcode: filter.classcode,
            search: filter.search,
            process_type: filter.process_type,
          },
        };

        if (!filter.buyer_id) {
          requestQuery.variables.buyer_id = '';
        }
        if (!filter.classcode) {
          requestQuery.variables.classcode = '';
        }
        if (!filter.search) {
          requestQuery.variables.search = '';
        }
        if (!filter.process_type) {
          requestQuery.variables.process_type = '';
        }

        const result = await apolloClient.query(requestQuery);
        if (result && result.data) {
          commit('SET_REPORTCHARTS', result.data.search_report);
        }
      } catch (err) {
        window.console.error(err);
        return [];
      }
      return [];
    },
  },
  mutations: {
    SET_SUPPLIERMATCH(state, data) {
      Vue.set(state, 'supplier_match', data);
    },
    SET_SUPPLIERMATCH_COUNT(state, data) {
      Vue.set(state, 'supplier_match_count', data);
    },
    SET_PROVIDERCATEGORIES(state, data) {
      Vue.set(state, 'categoriesSearchedInfo', data);
    },
    SET_PROVIDERBUYERS(state, data) {
      Vue.set(state, 'buyersSearchedInfo', data);
    },
    SET_PROVIDERPROCESSTYPE(state, data) {
      Vue.set(state, 'processTypeSearchedInfo', data);
    },
    SET_REPORTCHARTS(state, data) {
      Vue.set(state, 'report_chart', data);
    },
  },
  getters: {
    supplierMatchInfo: state => state.supplier_match,
    supplierMatchCountInfo: state => state.supplier_match_count,
    categoriesSearchedInfo: state => state.categoriesSearchedInfo,
    buyersSearchedInfo: state => state.buyersSearchedInfo,
    processTypeSearchedInfo: state => state.processTypeSearchedInfo,
    reportAndChartInfo: state => state.report_chart,
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/supplier/report.js